import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { clsx as f } from "../../../../node_modules/clsx/dist/clsx.m.js";
import n from "../FileUpload.module.scss.js";
import i from "../../Flex/Flex.js";
import g from "../../Icon/Icon.js";
import { Typography as l } from "../../Typography/Typography.js";
import C from "../Icons/Pdf.svg.js";
import w from "../Icons/Image.svg.js";
import v from "../Icons/CSV.svg.js";
import z from "../Icons/Doc.svg.js";
import I from "../Icons/XLS.svg.js";
import b from "../Icons/General.svg.js";
import k from "../../LoadingIndicator/LoadingIndicator.js";
import o from "../../CompactButton/CompactButton.js";
const V = ({
  errorMessage: m,
  file: r,
  onHandleRemove: s,
  loadingPercentage: d,
  onHandleDownload: p,
  withPreview: x,
  withRemoveIcon: j,
  onHandleReload: u
}) => {
  const h = (e) => {
    var a;
    return (a = e == null ? void 0 : e.type) != null && a.startsWith("image/") ? w : e.type === "application/pdf" ? C : e.type === "text/csv" ? v : e.type === "application/msword" ? z : e.type === "application/vnd.ms-excel" || e.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? I : b;
  }, y = (e) => e.status !== "loading" ? /* @__PURE__ */ t.jsxs(i, { style: { gap: 8 }, children: [
    x && /* @__PURE__ */ t.jsx(t.Fragment, { children: e.status === "success" ? /* @__PURE__ */ t.jsx(
      o,
      {
        size: "small",
        variant: "white",
        icon: "eye",
        onClick: (a) => {
          window.open(e.preview);
        },
        testId: "eye-button"
      }
    ) : u && /* @__PURE__ */ t.jsx(
      o,
      {
        size: "small",
        variant: "white",
        icon: "refresh-ccw-01",
        onClick: (a) => {
          u(e);
        }
      }
    ) }),
    p && /* @__PURE__ */ t.jsx(
      o,
      {
        size: "small",
        variant: "white",
        icon: "download-01",
        testId: "remove-button-v1",
        onClick: () => p(e)
      }
    ),
    j && /* @__PURE__ */ t.jsx(
      o,
      {
        size: "small",
        variant: "white",
        icon: "trash-03",
        testId: "remove-button",
        onClick: (a) => {
          a.preventDefault(), s == null || s(e);
        }
      }
    )
  ] }) : /* @__PURE__ */ t.jsx(
    o,
    {
      size: "small",
      variant: "white",
      icon: "x",
      testId: "remove-button-v1",
      onClick: () => s == null ? void 0 : s(e)
    }
  ), c = (() => {
    switch (r.status) {
      case "rejected":
        return !m;
      case "success":
        return !r.size || r.size === "0";
      default:
        return !1;
    }
  })();
  return /* @__PURE__ */ t.jsx(
    i,
    {
      flexCol: !0,
      style: { gap: 8 },
      "data-testid": "file-upload-component",
      children: /* @__PURE__ */ t.jsxs(
        i,
        {
          justifyBetween: !0,
          itemsCenter: !0,
          className: f(n.attachmentCardContainer, {
            [n.rejectedFile]: r.status === "rejected"
          }),
          children: [
            /* @__PURE__ */ t.jsxs(i, { style: { gap: 8 }, children: [
              r.status === "loading" ? /* @__PURE__ */ t.jsx(k, {}) : r.status === "success" ? /* @__PURE__ */ t.jsx(
                "img",
                {
                  src: h(r),
                  alt: String(r.type),
                  style: { width: 32, height: 32 }
                }
              ) : /* @__PURE__ */ t.jsx("div", { className: n.rejectedTypeContainer, children: /* @__PURE__ */ t.jsx(g, { name: "alert-circle" }) }),
              /* @__PURE__ */ t.jsxs(
                i,
                {
                  flexCol: !c,
                  itemsCenter: c,
                  justifyBetween: !0,
                  children: [
                    /* @__PURE__ */ t.jsx(
                      l,
                      {
                        text: r.name,
                        variant: "interface/medium/sm",
                        textColor: "color/fg/bold"
                      }
                    ),
                    !c && /* @__PURE__ */ t.jsx(
                      l,
                      {
                        text: r.status === "rejected" ? m : r.status === "loading" ? `${r.size} · ${d}% Uploaded` : r.size,
                        className: n.fileSize,
                        variant: "caption",
                        textColor: r.status == "rejected" ? "color/fg/danger/default" : "color/fg/lighter"
                      }
                    )
                  ]
                }
              )
            ] }),
            y(r)
          ]
        }
      )
    }
  );
};
export {
  V as default
};
//# sourceMappingURL=FileInfoBox.js.map
